import _defineProperty from "@babel/runtime/helpers/defineProperty";
import parse from './parse';
import encode from './encode';
export { LANGUAGE_MAP as CONFLUENCE_LANGUAGE_MAP } from './languageMap';
export class ConfluenceTransformer {
  constructor(schema) {
    _defineProperty(this, "parse", html => parse(html, this.schema));

    _defineProperty(this, "encode", node => encode(node, this.schema));

    this.schema = schema;
  }

}